import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import AdminProfile from 'views/AdminProfile/AdminProfile';
import Complaint from 'views/Complaint';
import Laundary from 'views/Laundary';
import ReservationDashboard from 'views/Reservation/Components/ReservationDashboard';
import Food from 'views/ReservationFood/index';
import ComplaintDashboard from 'views/Complaint/ComplaintDashboard';
import Customer from 'views/Customer';
import CustomerDashboard from 'views/Customer/Components';
import HotelProfile from 'views/HotelProfile/hotelProfile';
import MainDashboard from 'views/mainDashboard/Default';
import HotelManagement from 'views/HotelManagement';
import HotelManagementDashboard from 'views/HotelManagement/Components';
import StaffManagment from 'views/Staff';
import Restaurant from 'views/restaurant';
import EmployeeDashboard from 'views/Staff/Components';
import AdminComplaint from 'views/AdminComplaint';
import AdminComplaintDashboard from 'views/AdminComplaint/ComplaintDashboard';
import AdminDashboard from 'views/AdminDashboard';
import AdminReports from 'views/Adminreports';
import AdminPackages from 'views/AdminSubscriptions';
import AdminPayments from 'views/AdminPayments';
import PackagesDashboard from 'views/AdminSubscriptions/Components/PackagesDashboard';
import HotelSubscriptionsDetails from 'views/HotelSubscriptions';
import HotelPaymentsDetails from 'views/HotelPayments';
import VisitorDashboard from 'views/VisitorInformation/Components';
import SeparateFoodView from 'views/SeparateFoodOrder/FoodView';

import PoliceReports from 'views/dashboard/PoliceReports';
import GeneralReports from 'views/dashboard/GeneralReports';
import KotReports from 'views/dashboard/KotReports';
import CustomerBookingHistory from 'views/Customer/Components/CustomerBookingHistory';

import ViewInvoices from 'views/Invoices';

// dashboard routing
const DashboardDefault = Loadable(lazy(() => import('views/dashboard/Default')));
const RoomManagement = Loadable(lazy(() => import('views/Room')));
const Reservation = Loadable(lazy(() => import('views/Reservation')));
const Expenses = Loadable(lazy(() => import('views/Expenses')));
const KitchenOrderTicket = Loadable(lazy(() => import('views/KitchenOrderTicket')));
const RoomTypeMaster = Loadable(lazy(() => import('views/RoomTypeMaster')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: <MainLayout />,
  children: [
    {
      path: '/',
      element: <MainDashboard />
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'app',
          element: <MainDashboard />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'roomtypemanagement',
          element: <RoomTypeMaster />
        }
      ]
    },

    {
      path: 'dashboard',
      children: [
        {
          path: 'roommanagement',
          element: <RoomManagement />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'reservation',
          element: <Reservation />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'staffmanagement',
          element: <StaffManagment />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'customers',
          element: <Customer />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'expenses',
          element: <Expenses />
        }
      ]
    },

    // {
    //   path: 'dashboard',
    //   children: [
    //     {
    //       path: 'kot',
    //       element: <KitchenOrderTicket />
    //     }
    //   ]
    // },


    {
      path: 'dashboard',
      children: [
        {
          path: 'restaurant',
          element: <Restaurant />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'complaint',
          element: <Complaint />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'laundary',
          element: <Laundary />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'reports',
          element: <DashboardDefault />
        }
      ]
    },

    {
      path: 'dashboard',
      children: [
        {
          path: 'policyreports',
          element: <PoliceReports />
        }
      ]
    },

    {
      path: 'dashboard',
      children: [
        {
          path: 'generalreport',
          element: <GeneralReports />
        }
      ]
    },

    {
      path: 'dashboard',
      children: [
        {
          path: 'kotreports',
          element: <KotReports />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: '/dashboard/reservation/addfood/:id',
          element: <Food />
        }
      ]
    },

    {
      path: 'dashboard',
      children: [
        {
          path: '/dashboard/separatefood/addfood',
          element: <SeparateFoodView />
        }
      ]
    },

    {
      path: 'dashboard',
      children: [
        {
          path: '/dashboard/lead/view/:id',
          element: <RoomManagement />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: '/dashboard/customer/view/:phone',
          element: <CustomerDashboard />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: '/dashboard/customer/view/specificbooking/:id',
          element: <CustomerBookingHistory />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: '/dashboard/employee/view/:id',
          element: <EmployeeDashboard />
        }
      ]
    },

    {
      path: 'dashboard',
      children: [
        {
          path: '/dashboard/complaint/view/:id',
          element: <ComplaintDashboard />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: '/dashboard/reservation/view/:id',
          element: <ReservationDashboard />
        }
      ]
    },

    {
      path: 'dashboard',
      children: [
        {
          path: '/dashboard/hotel',
          element: <HotelManagement />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: '/dashboard/hotel/view/:id',
          element: <HotelManagementDashboard />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'profile',
          element: <HotelProfile />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'invoice',
          element: <ViewInvoices />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'adminprofile',
          element: <AdminProfile />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'admincomplaint',
          element: <AdminComplaint />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: '/dashboard/admincomplaint/view/:id',
          element: <AdminComplaintDashboard />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: '/dashboard/admindashboard',
          element: <AdminDashboard />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: '/dashboard/adminreports',
          element: <AdminReports />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: '/dashboard/subscriptions',
          element: <AdminPackages />
        }
      ]
    },
    // {
    //   path: 'dashboard',
    //   children: [
    //     {
    //       path: '/dashboard/hotelsubscriptions',
    //       element: <HotelSubscriptionsDetails />
    //     }
    //   ]
    // },
    {
      path: 'dashboard',
      children: [
        {
          path: '/dashboard/payments',
          element: <AdminPayments />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: '/dashboard/hotelpayments',
          element: <HotelPaymentsDetails />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: '/dashboard/packages/view/:id',
          element: <PackagesDashboard />
        }
      ]
    },
    {
      path: 'dashboard',
      children: [
        {
          path: '/dashboard/visitor/view/:phone',
          element: <VisitorDashboard />
        }
      ]
    }
  ]
};

export default MainRoutes;
